/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dcoPreviewList.vue?vue&type=template&id=20dda274&scoped=true&"
import script from "./dcoPreviewList.vue?vue&type=script&lang=js&"
export * from "./dcoPreviewList.vue?vue&type=script&lang=js&"
import style0 from "./dcoPreviewList.vue?vue&type=style&index=0&id=20dda274&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dda274",
  null
  
)

export default component.exports